<template>
  <section>
    <spinner v-if="disableSubmitDetailTransaction"></spinner>
    <errors v-if="isVisibleErrorsModal"></errors>
    <question v-if="display"></question>
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="row">
          Transaction {{transaction.transactionId}}
        </div>
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <button type="button" class="btn-back icon-back bottom-margin" v-on:click="goBack()">Go back</button>

      <div class="row">
        <div class="col-lg-12">

          <div id="panelChart9" class="panel panel-default">
            <div class="panel-heading top-margin">
              <div class="panel-title">
                Transaction {{this.transaction.transactionId}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{formatType(this.transaction.type, 'admin')}}
              </div>
            </div>

          <div class="line-separator top-margin"></div>
            <div class="row">
              <div class="col-sm-3">
                <label>Account name:</label>
              </div>

              <div class="col-sm-3">
                <p>{{ account.accountName }}</p>
              </div>

              <div class="col-sm-3">
                <label>Term:</label>
              </div>

              <div class="col-sm-3">
                <p>{{formatTerm(note.interestTerm)}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <label>Name:</label>
              </div>

              <div class="col-sm-3">
                <p>{{user.fullName}}</p>
              </div>

              <div class="col-sm-3">
                <label>Rate:</label>
              </div>

              <div class="col-sm-3">
                <p>{{note.interestRate.toFixed(2).toString()}}{{note.interestRate ? '%' : ''}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <label>Email:</label>
              </div>

              <div class="col-sm-3">
                <p>{{user.email}}</p>
              </div>

              <div class="col-sm-3">
                <label>Amount:</label>
              </div>

              <div class="col-sm-3">
                <p>{{formatAmount(transaction.amount)}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <label>Telephone number:</label>
              </div>

              <div class="col-sm-3">
                <p>{{user.primaryPhoneNum}}</p>
              </div>

              <div class="col-sm-3">
                <label>Transaction date:</label>
              </div>

              <div class="col-sm-3">
                <p>{{formatDate(transaction.createdAt)}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <label>Id:</label>
              </div>

              <div class="col-sm-3">
                <p>{{this.transaction.transactionId}}</p>
              </div>

              <div class="col-sm-3">
                <label>Last updated date:</label>
              </div>

              <div class="col-sm-3">
                <p>{{formatDate(transaction.updatedAt)}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <label>Transaction type:</label>
              </div>

              <div class="col-sm-3">
                <p>{{formatType(transaction.type)}}</p>
              </div>

              <div class="col-sm-3">
                <label>Dwolla transaction:</label>
              </div>

              <div class="col-sm-3">
                <p>{{transaction.dwollaTransferId}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <label>Note number:</label>
              </div>

              <div class="col-sm-3">
                <p>{{note.noteId}}</p>
              </div>

              <div class="col-sm-3">
                <label>Status:</label>
              </div>

              <div class="col-sm-3">
                <p class="danger">{{transaction.status}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3"></div>
              <div class="col-sm-3"></div>
              <div class="col-sm-3">
                <div>
                  <label>Transaction failure reason:</label>
                </div>
              </div>
              <div class="col-sm-3">
                <div>
                  <p class="danger">{{transaction.failureReason}}</p>
                </div>
              </div>
            </div>

            <div class="line-separator top-margin"></div>

            <div class="row">
              <div class="col-sm-12">
                <label>Action comment:</label>
                <restricted-textarea
                  :input="transaction.comment || ''"
                  :limit="255"
                  id="comment"
                  placeholder="Please input a comment to mark a transaction as Lost."
                  @inputUpdated="commentUpdated"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 m-top-10">
                <p v-if="!this.transaction.comment">Please add a comment if you decide to mark a transaction as Lost or you have processed it manually</p>
                <p v-if="transaction.comment && !transaction.lost && transaction.comment === previousLostComment"><i>Please append a comment before marking this transaction as lost.</i></p>
                <p v-if="transaction.comment && transaction.lost && transaction.comment === previousLostComment"><i>Please append a comment before marking this transaction as unlost.</i></p>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <button type="submit"
                  v-on:click="submitSaveLostComment" v-bind:disabled="disableSubmitDetailTransaction || !transaction.comment"
                  class="btn btn-info btn-lg button-save">Save</button>
              </div>
            </div>

            <div class="line-separator top-margin"></div>

            <div class="row top-margin" v-if="!shouldUserNotBeAllowedToRetry()">
              <div class="col-md-12">
                <div class="alert alert-info tip-alert">
                  <i class="fa fa-info-circle"></i>
                  All transactions must be entered by <strong>4:55 p.m. ET</strong> to be processed today.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <button type="submit"
                  v-bind:disabled="shouldUserNotBeAllowedToRetry()"
                  v-on:click="submitRetryTransaction"
                  class="btn btn-info btn-lg button-retry mr-lg">Retry</button>
              <button v-if="!transaction.lost"
                  type="submit"
                  v-bind:disabled="disableSubmitDetailTransaction || !transaction.comment
                  || transaction.comment === previousLostComment"
                  v-on:click="showLostConfirmationModal"  class="btn btn-info btn-lg button-lost mr-lg">Lost
              </button>
                <button v-if="transaction.lost"
                    type="submit"
                    v-bind:disabled="disableSubmitDetailTransaction || !transaction.comment || transaction.comment === previousLostComment"
                    v-on:click="showLostConfirmationModal"
                    class="btn btn-info btn-lg button-lost mr-lg">Unlost</button>
                <button type="submit"
                    v-bind:disabled="disableSubmitDetailTransaction || transaction.lost"
                    v-on:click="openModalToAskForProcessing"
                    class="btn btn-info btn-lg button-processed mr-lg">Processed manually</button>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div role="alert" v-if="lostSuccess" class="alert lost-comment alert-success">
                   {{ successMessage }}
                </div>
                <div role="alert" v-if="lostCommentSuccess" class="alert lost-comment alert-success">
                   Comment succesfully saved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import {
    mapMutations,
    mapActions,
    mapState,
  } from 'vuex';
  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    HIDE_QUESTION_MODAL,
    SHOW_QUESTION_MODAL,
    DISABLE_SUBMIT_DETAIL_TRANSACTION,
    ENABLE_SUBMIT_DETAIL_TRANSACTION,
  } from '@/store/mutation-types';

  import Question from '@/components/modals/Question';
  import Errors from '@/components/modals/Errors';
  import RestrictedTextArea from '@/components/formControls/RestrictedTextArea';
  import { formatDate, formatAmount, formatTerm, formatType } from '@/util';
  import spinner from '@/components/widgets/Spinner';
  import moment from 'moment';
  import TransactionTypes from '@/data/static/transactionTypes';

  import {
    Constants,
  } from '../data/static/constants';

  const mix = {
    methods: {
      formatDate,
      formatAmount,
      formatTerm,
      formatType,
    },
  };

  export default {
    name: 'failedTransactionDetail',
    async beforeMount() {
      this.setParams();
      await this.loadTransactionDetail();
    },
    data() {
      return {
        transactionId: '',
        lostSuccess: false,
        lostCommentSuccess: false,
        previousLostComment: '',
        successMessage: '',
        account: '',
        note: {
          interestRate: 0,
        },
        transaction: {
          noteId: '',
          amount: 0,
          dwollaTransferId: '',
          status: '',
          failureReason: '',
          createdAt: '',
          updatedAt: '',
          comment: '',
        },
        user: {
          name: '',
        },
      };
    },
    mixins: [mix],
    computed: {
      ...mapState('transaction', [
        'disableSubmitDetailTransaction',
      ]),
      ...mapState('authentication', [
        'states',
      ]),
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('question', [
        'display',
      ]),
      failableTransactions() {
        return [
          TransactionTypes.PAID_INT,
          TransactionTypes.REPAID_ACCT,
          TransactionTypes.REPAID_ACCT_FULL,
          TransactionTypes.REPAID_ACCT_PARTIAL,
        ];
      },
      canTransactionBeRetriedWithDwollaOrLob() {
        return this.failableTransactions.includes(this.transaction.type);
      },
    },
    methods: {
      ...mapActions('transaction', [
        'getTransaction',
        'retryTransaction',
        'saveLostComment',
        'lostTransaction',
        'setTransactionAsProcessed',
        'updateTransaction',
      ]),
      ...mapActions('note', [
        'getNote',
      ]),
      ...mapActions('account', [
        'getAccount',
      ]),
      ...mapActions('accountCreation', [
        'getUserDetail',
      ]),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapMutations('transaction', {
        disableSubmitDetailTransactionMutation: DISABLE_SUBMIT_DETAIL_TRANSACTION,
        enableSubmitDetailTransactionMutation: ENABLE_SUBMIT_DETAIL_TRANSACTION,
      }),
      setParams() {
        this.transactionId = this.$route.params.id;
      },
      commentUpdated($event) {
        this.transaction.comment = $event;
      },
      async loadTransactionDetail() {
        try {
          this.disableSubmitDetailTransactionMutation();
          const transaction = await this.getTransaction(this.transactionId);
          const note = await this.getNote(transaction.noteId);
          const account = await this.getAccount(note.accountId);
          const user = await this.getUserDetail(account.primaryInvestorId);
          this.transaction = transaction;
          this.note = note;
          this.account = account;
          this.user = user;
          this.transaction.transactionDate = moment(this.transaction.createdAt);
          this.transaction.lastUpdatedDate = moment(this.transaction.updatedAt);
          this.enableSubmitDetailTransactionMutation();
          return Promise.resolve(true);
        } catch (error) {
          if (error !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['Something went wrong retrieving the transaction detail. Please try again.']);
            this.showErrorsModal();
          }
          this.enableSubmitDetailTransactionMutation();
          return Promise.resolve(false);
        }
      },
      async submitRetryTransaction() {
        try {
          if (this.canTransactionBeRetriedWithDwollaOrLob) {
            this.goToRetryTransactionManually();
          } else {
            await this.retryTransaction(this.transactionId);
            this.$router.push({ name: 'FailedTransactionList' });
          }
        } catch (error) {
          this.$router.push({ name: 'FailedTransactionList' });
        }
      },
      async goToRetryTransactionManually() {
        this.$router.push({
          name: 'RetryFailedTransaction',
          params: {
            transaction: this.transaction,
            account: this.account,
          },
        });
      },
      submitSaveLostComment() {
        this.saveLostComment({ id: this.transactionId, comment: this.transaction.comment })
        .then(() => {
          this.lostSuccess = false;
          this.lostCommentSuccess = true;
        });
      },
      getCorrespondingMessageLostAction(lostTransaction) {
        return !lostTransaction ? Constants.failedTransactiondetail.markAsLostMessage
          : Constants.failedTransactiondetail.markAsUnlostMessage;
      },
      getCorrespondingSuccessMessageLostAction(lostTransaction) {
        return lostTransaction ? Constants.failedTransactiondetail.flaggedAsLostSuccessMessage
          : Constants.failedTransactiondetail.flaggedAsUnlostSuccessMessage;
      },
      getMethodToRequestTheProcessingOfTransaction() {
        const method = async () => {
          await this.updateTransaction({ transactionId: this.transaction.id,
            payload: {
              comment: this.transaction.comment,
            },
          });
          await this.setTransactionAsProcessed({ transactionId: this.transaction.id })
            .then(() => {
              this.hideQuestionModal();
              this.$router.push({ name: 'FailedTransactionList' });
            })
            .catch(() => {
              this.hideQuestionModal();
              this.setErrorsModalInfo(['Something went wrong. Please try again.']);
              this.showErrorsModal();
            });
        };

        return method;
      },
      openModalToAskForProcessing() {
        this.showQuestionModal({
          title: 'Set transaction as processed',
          question: `Are you sure that you have processed this transaction manually?
          Once you confirm, you will not see
          this transaction on the Cancelled / Failed view any more.`,
          method: this.getMethodToRequestTheProcessingOfTransaction(),
          yesButtonText: 'Confirm',
          hideCancelButton: false,
        });
      },
      showLostConfirmationModal() {
        this.showQuestionModal({
          title: !this.transaction.lost ? 'Lost' : 'Unlost',
          question: this.getCorrespondingMessageLostAction(this.transaction.lost),
          method: async () => {
            try {
              await this.updateTransaction({ transactionId: this.transaction.id,
                payload: {
                  comment: this.transaction.comment,
                },
              });
              await this.lostTransaction({ transactionId: this.transaction.id });
              const transaction = await this.getTransaction(this.transactionId);
              this.transaction = transaction;
              this.successMessage = this.getCorrespondingSuccessMessageLostAction(transaction.lost);
              this.previousLostComment = this.transaction.comment;
              this.hideQuestionModal();
              this.lostSuccess = true;
              this.lostCommentSuccess = true;
            } catch (error) {
              this.hideQuestionModal();
            }
          },
          yesButtonText: Constants.purchaseNote.modalYesButtonText,
          hideCancelButton: false,
        });
      },
      shouldUserNotBeAllowedToRetry() {
        return (
          this.disableSubmitDetailTransaction ||
          this.transaction.lost ||
          (!this.canTransactionBeRetriedWithDwollaOrLob &&
            this.transaction.type !== TransactionTypes.FUNDING &&
            this.transaction.type !== TransactionTypes.PURCHASE_NOTE)
        );
      },
      goBack() {
        this.$router.push({ name: 'FailedTransactionList' });
      },
    },
    components: {
      'restricted-textarea': RestrictedTextArea,
      errors: Errors,
      question: Question,
      spinner,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .left-margin {
    margin-left: 2%;
  }
  .right-margin {
    margin-left: -2%;
  }
  .top-margin {
    margin-top: 2%;
  }
  .bottom-margin {
    margin-bottom: 1%;
  }
  .row {
    margin-top: 1%;
  }
  label {
    color: #888;
    font-size: 14px;
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .panel-heading {
    background-color: white !important;
    font-weight: 700;
    color: #726f6f;
    padding: 0px;
  }
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .button-retry {
    background-color: #127285;
  }
  .button-save {
    background-color: #127285;
  }
  .button-lost {
    background-color: white;
    border-color: #127285;
    color: #127285;
  }
  .button-processed {
    background-color: white;
    border-color: #00788d;
    color: #00788d;
  }
  .danger {
    color: red;
  }
  .content-wrapper {
    border-top: none;
  }
  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    padding-left: 20px;
  }
  .icon-back {
    position:relative;
  }
  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position:absolute;
    left: 0px;
 }
 .comment-label-below {
   margin-left: 3%;
 }
 .comment-box-container {
   margin-left: 2%;
   margin-right: 2%;
 }
 .m-top-10{
   margin-top:10px;
 }
 .tip-alert {
   background-color: #fcf8e3;
   border: 1px solid #faebcc;
   color: #8a6d3b;
   padding: 10px 15px;
   border-radius: 4px;
   margin-top: 10px;
   font-size: 14px;
 }
 .tip-alert i {
   margin-right: 8px;
 }

</style>



// WEBPACK FOOTER //
// FailedTransactionDetail.vue?595f7984